import { Switch, Route } from "react-router-dom";
import React from "react";
import routes from "./Routes";
import Redirect from "react-router-dom/es/Redirect";

let _routes = routes.map((x, i) => (
  <Route path={x.to} exact={!!x.exact} render={x.render} key={i} />
));

const Main = () => (
  <main>
    <Switch>
      {_routes}
      <Redirect from="/" to="/samples" />
    </Switch>
  </main>
);

export default Main;
